export default __webpack_public_path__ + "static/icon-14-5-971a8d7934b580bff4a7ddc4d0d5ae3b.png";